import loadRecaptchaAPI from 'Utils/loadRecaptchaAPI';

export default function addRecaptcha(el, options, lang) {
  return loadRecaptchaAPI(function(){
    grecaptcha.render(el, options);
  }, lang);
}
